var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widthCen"},[_c('section',{staticClass:"fwbhtml",domProps:{"innerHTML":_vm._s(_vm.Info)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }